import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55e047c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "senior" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "senior_title" }, "默认设置", -1))
const _hoisted_3 = {
  key: 0,
  class: "senior_radio"
}
const _hoisted_4 = { class: "senior_color" }
const _hoisted_5 = { class: "senior_color_list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "senior_color_background" }
const _hoisted_8 = {
  key: 0,
  class: "senior_color_background background_select"
}
const _hoisted_9 = { class: "senior_radio" }
const _hoisted_10 = { class: "senior_color" }
const _hoisted_11 = { class: "senior_color_list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "senior_color_background" }
const _hoisted_14 = { class: "senior_color_background background_select" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "senior_title" }, "选中设置", -1))
const _hoisted_16 = {
  key: 1,
  class: "senior_radio"
}
const _hoisted_17 = { class: "senior_color" }
const _hoisted_18 = { class: "senior_color_list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "senior_color_background" }
const _hoisted_21 = { class: "senior_color_background background_select" }
const _hoisted_22 = { class: "senior_radio" }
const _hoisted_23 = { class: "senior_color" }
const _hoisted_24 = { class: "senior_color_list" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "senior_color_background" }
const _hoisted_27 = { class: "senior_color_background background_select" }

import { ref } from 'vue';
import { Radio } from 'ant-design-vue';
import { ElColorPicker } from 'element-plus';
import emitter from '@/utils/mitt';
import { colorList } from '../components/PublicFunction';

export default /*#__PURE__*/_defineComponent({
  __name: 'lable',
  props: {
  lable: {},
},
  setup(__props) {

const props: any = __props;

const aRadioGroup = Radio.Group;


const lable = ref({ ...props.lable });
const senior = ref({ ...lable.value.senior });

const toVisualization = () => {
  senior.value.defaultLabel == 0 ? (senior.value.defaultLabelColor = '#F2F3F7') : '';
  senior.value.defaultText == 0 ? (senior.value.defaultTextColor = '#00CCB0') : '';
  senior.value.selectLabel == 0 ? (senior.value.selectLabelColor = '#00CCB0') : '';
  senior.value.selecttText == 0
    ? (senior.value.selecttTextColor = lable.value.style == 2 || lable.value.style == 3 ? '#fff' : '#00CCB0')
    : '';
  lable.value.senior = senior.value;
  emitter.emit('visualization', lable.value);
};

const getColor = (id: number, color: string) => {
  id == 0
    ? (senior.value.defaultLabelColor = color)
    : id == 1
    ? (senior.value.defaultTextColor = color)
    : id == 2
    ? (senior.value.selectLabelColor = color)
    : (senior.value.selecttTextColor = color);
  toVisualization();
};

return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ((props.lable.type == 6 && props.lable.style == 2) || (props.lable.type == 7 && props.lable.style == 1))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" 标签颜色： "),
          _createVNode(_unref(aRadioGroup), {
            onChange: toVisualization,
            class: "senior_radio_group",
            name: "radioGroup",
            value: senior.value.defaultLabel,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((senior.value.defaultLabel) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: "0" }, {
                default: _withCtx(() => [
                  _createTextVNode("默认")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: "1" }, {
                default: _withCtx(() => [
                  _createTextVNode("自定义")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (getColor(0, item)),
            key: index,
            class: "color_list_every",
            style: _normalizeStyle({ background: item })
          }, null, 12, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(" 自定义标签颜色： "),
        (senior.value.defaultLabelColor)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(senior.value.defaultLabelColor) + " ", 1),
              _createVNode(_unref(ElColorPicker), {
                onChange: toVisualization,
                modelValue: senior.value.defaultLabelColor,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((senior.value.defaultLabelColor) = $event)),
                predefine: _unref(colorList)
              }, null, 8, ["modelValue", "predefine"])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, senior.value.defaultLabel == 1]
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createTextVNode(" 文字颜色： "),
      _createVNode(_unref(aRadioGroup), {
        onChange: toVisualization,
        class: "senior_radio_group",
        name: "radioGroup",
        value: senior.value.defaultText,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((senior.value.defaultText) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio, { value: "0" }, {
            default: _withCtx(() => [
              _createTextVNode("默认")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio, { value: "1" }, {
            default: _withCtx(() => [
              _createTextVNode("自定义")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (getColor(1, item)),
            key: index,
            class: "color_list_every",
            style: _normalizeStyle({ background: item })
          }, null, 12, _hoisted_12))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createTextVNode(" 自定义文字颜色： "),
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(senior.value.defaultTextColor) + " ", 1),
          _createVNode(_unref(ElColorPicker), {
            onChange: toVisualization,
            modelValue: senior.value.defaultTextColor,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((senior.value.defaultTextColor) = $event)),
            predefine: _unref(colorList)
          }, null, 8, ["modelValue", "predefine"])
        ])
      ])
    ], 512), [
      [_vShow, senior.value.defaultText == 1]
    ]),
    _hoisted_15,
    ((props.lable.type == 6 && props.lable.style !== 1) || (props.lable.type == 7 && props.lable.style == 1))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createTextVNode(" 标签颜色： "),
          _createVNode(_unref(aRadioGroup), {
            onChange: toVisualization,
            class: "senior_radio_group",
            name: "radioGroup",
            value: senior.value.selectLabel,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((senior.value.selectLabel) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: "0" }, {
                default: _withCtx(() => [
                  _createTextVNode("默认")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: "1" }, {
                default: _withCtx(() => [
                  _createTextVNode("自定义")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (getColor(2, item)),
            key: index,
            class: "color_list_every",
            style: _normalizeStyle({ background: item })
          }, null, 12, _hoisted_19))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createTextVNode(" 自定义标签颜色： "),
        _createElementVNode("div", _hoisted_21, [
          _createTextVNode(_toDisplayString(senior.value.selectLabelColor) + " ", 1),
          _createVNode(_unref(ElColorPicker), {
            onChange: toVisualization,
            modelValue: senior.value.selectLabelColor,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((senior.value.selectLabelColor) = $event)),
            predefine: _unref(colorList)
          }, null, 8, ["modelValue", "predefine"])
        ])
      ])
    ], 512), [
      [_vShow, senior.value.selectLabel == 1]
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createTextVNode(" 文字颜色： "),
      _createVNode(_unref(aRadioGroup), {
        onChange: toVisualization,
        class: "senior_radio_group",
        name: "radioGroup",
        value: senior.value.selecttText,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((senior.value.selecttText) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio, { value: "0" }, {
            default: _withCtx(() => [
              _createTextVNode("默认")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio, { value: "1" }, {
            default: _withCtx(() => [
              _createTextVNode("自定义")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (getColor(3, item)),
            key: index,
            class: "color_list_every",
            style: _normalizeStyle({ background: item })
          }, null, 12, _hoisted_25))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createTextVNode(" 自定义文字颜色： "),
        _createElementVNode("div", _hoisted_27, [
          _createTextVNode(_toDisplayString(senior.value.selecttTextColor) + " ", 1),
          _createVNode(_unref(ElColorPicker), {
            onChange: toVisualization,
            modelValue: senior.value.selecttTextColor,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((senior.value.selecttTextColor) = $event)),
            predefine: _unref(colorList)
          }, null, 8, ["modelValue", "predefine"])
        ])
      ])
    ], 512), [
      [_vShow, senior.value.selecttText == 1]
    ])
  ]))
}
}

})